import { useEffect } from 'react'

import { useFetchContact } from '../hooks'
import { resetContactUpdate, selectExternalId } from '../../../store/meetingSummary/contactUpdate'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'

interface UpdateExternalContactModalInitializationProps {
  serviceId: string
}

export const UpdateExternalContactModalInitialization = ({ serviceId }: UpdateExternalContactModalInitializationProps) => {
  useInitializeContactForExternalContactUpdate(serviceId)
  useCleanupContactUpdate()

  return null
}

const useInitializeContactForExternalContactUpdate = (serviceId: string) => {
  const externalId = useAppSelector(selectExternalId)

  const { fetchContact } = useFetchContact({ serviceId })

  useEffect(() => {
    if (!externalId) {
      return
    }
    fetchContact(externalId)
  }, [externalId, fetchContact])
}

const useCleanupContactUpdate = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    return () => {
      dispatch(resetContactUpdate())
    }
  }, [dispatch])
}
